const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//	SEARCH
		// ===================================
		case "REVIEW_SEARCH_IN_PROGRESS":
			return {
				...getBasicState(state),
				inProgress: 1
			};

		case "REVIEW_SEARCH_HAS_ERROR":
			return {
				...state,
				error: action.error,
				inProgress: 0
			};

		case "REVIEW_SEARCH_SUCCESS":
			return {
				...state,
				inProgress: 0
			};

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc.
 * @param object state
 */
function getBasicState(state) {
	const { error, success, ...newState } = state;
	return newState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/reviewSearch.js